import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import React, { useEffect, useRef, useState } from "react";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormDatePicker from "../../components/formFields/FormDateField";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../../app/store";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearGhatReceiptDetail } from "./ghatReceiptSlice";
import moment from "moment";
import {
  getKarigarListByProcess,
  getKarigarStock,
} from "../karigar/services/karigar.services";
import {
  createGhatReceipt,
  getGhatReceiptById,
  updateGhatReceipt,
} from "./services/gharteceipt.services";
import { findAllActiveItem } from "../item/services/item.services";
import { findAllActivePurity } from "../purity/services/purity.services";
import { findAllActiveProcess } from "../process/services/process.services";
import GhatReceiptOrderArray from "./GhatReceiptOrderArray";
import GhatReceiptOrderEntryArray from "./GhatReceiptOrderEntryArray";
import { findAllActiveUnit } from "../unit/services/unit.services";
import { findAllActiveItemCategory } from "../itemcategory/services/itemcategory.services";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { closeDialog } from "../../components/dialog/dialogSlice";
import { PRINT_ACCESS, PROCESS_ID } from "../../_contstants/common";
import { IKarigarListByProcess } from "../karigar/karigarModel";
import { clearKarigarStock } from "../karigar/karigarSlice";
import {
  checkAcessRights,
  formatToIndianCurrencyWithoutSymbol,
  formatWeight,
} from "../../_helper/helper";
import { FaEye } from "react-icons/fa";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const GhatOrderEntryChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const ghat_receipt_order = formRenderProps.valueGetter("ghat_receipt_order");
  const karigar_id = formRenderProps.valueGetter("karigar_id");
  const KarigarList = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const fetchKarigarStock = async (karigar_id: number) => {
    await dispatch(getKarigarStock(karigar_id));
  };
  useEffect(() => {
    if (karigar_id) {
      fetchKarigarStock(karigar_id);
    }
  }, [karigar_id]);

  useEffect(() => {
    if (karigar_id && KarigarList && KarigarList?.length > 0) {
      const selectedKarigar = KarigarList.find(
        (karigar) => karigar.karigar_id === karigar_id,
      );
      if (selectedKarigar) {
        const wastage = selectedKarigar?.wastage;
        formRenderProps.onChange(`karigar_wastage`, {
          value: wastage || 0,
        });
      }
    }
  }, [karigar_id, KarigarList]);

  useEffect(() => {
    if (ghat_receipt_order && ghat_receipt_order?.length > 0) {
      ghat_receipt_order.forEach((receipt_order: any, index: number) => {
        const netWeight =
          receipt_order.gross_weight - receipt_order.stone_weight;
        const phine =
          netWeight * ((receipt_order.purity + receipt_order.wastage) / 100);
        receipt_order.gross_weight - receipt_order.stone_weight;
        formRenderProps.onChange(`ghat_receipt_order.${index}.net_weight`, {
          value: netWeight,
        });
        formRenderProps.onChange(`ghat_receipt_order.${index}.phine`, {
          value: phine.toFixed(3),
        });
      });
    }
  }, [
    ghat_receipt_order?.map((item: any) => item.gross_weight).join("-"),
    ghat_receipt_order?.map((item: any) => item.stone_weight).join("-"),
    ghat_receipt_order?.map((item: any) => item.purity).join("-"),
    ghat_receipt_order?.map((item: any) => item.wastage).join("-"),
  ]);

  return null;
};

const CreateGhatReceipt: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const formLoading = useAppSelector((state) => state.ghatreceipt?.formLoading);
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  const GhatReceiptDetail = useAppSelector(
    (state: RootState) => state.ghatreceipt.GhatReceiptDetail,
  );
  const GhatReceiptOrderSave = useAppSelector(
    (state: RootState) => state.ghatreceipt.GhatReceiptOrderSave,
  );
  const karigarStock = useAppSelector((state) => state.karigar.KarigarStock);
  const ghat_receipt_guid = location?.state?.ghat_receipt_guid;
  const isPrintAccess = checkAcessRights(
    "/" + location.pathname.split("/")[1],
    PRINT_ACCESS,
  );
  const [formKey, setFormKey] = useState(1);
  const today = new Date();
  const maxDate =
    new Date(today.getFullYear(), today.getMonth(), today.getDate()) || null;

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [GhatReceiptDetail]);

  const handleFormClose = () => {
    navigate("/ghatissuereceipt");
  };

  useEffect(() => {
    dispatch(findAllActiveProcess());
    dispatch(getKarigarListByProcess(PROCESS_ID.ghat));
    dispatch(findAllActivePurity());
    dispatch(findAllActiveItem());
    dispatch(findAllActiveUnit());
    dispatch(findAllActiveItemCategory());
    return () => {
      dispatch(clearGhatReceiptDetail());
      dispatch(clearKarigarStock());
    };
  }, []);

  useEffect(() => {
    if (ghat_receipt_guid) {
      dispatch(getGhatReceiptById(ghat_receipt_guid));
    }
  }, [ghat_receipt_guid]);

  const handleSubmit = async (values: any) => {
    if (GhatReceiptOrderSave) return false;

    const formdata = {
      karigar_id: values.karigar_id ? +values.karigar_id : null,
      receipt_date: values.receipt_date
        ? moment(values.receipt_date).format("YYYY-MM-DD")
        : "",
      ghat_receipt_order: values.ghat_receipt_order
        ? values.ghat_receipt_order?.map((ghat_re_order: any) => ({
            id: ghat_re_order.id ? ghat_re_order.id : 0,
            ghat_issue_id: ghat_re_order.ghat_issue_id ?? 0,
            order_id: ghat_re_order.order_id,
            item_id: ghat_re_order.item_id,
            item_category_id: ghat_re_order.item_category_id,
            item_description: ghat_re_order.item_description,
            weight: ghat_re_order.weight,
            gross_weight: ghat_re_order.gross_weight,
            stone_weight: ghat_re_order.stone_weight
              ? ghat_re_order.stone_weight
              : 0,
            net_weight: ghat_re_order.net_weight ? ghat_re_order.net_weight : 0,
            purity: ghat_re_order.purity,
            wastage: ghat_re_order.wastage,
            phine: ghat_re_order.phine,
            iscaret: ghat_re_order.iscaret,
            isdesign: ghat_re_order.isdesign,
            isgoldcolor: ghat_re_order.isgoldcolor,
            isweight: ghat_re_order.isweight,
            issize: ghat_re_order.issize,
            ispolishcolor: ghat_re_order.ispolishcolor,
            isfinishorder: ghat_re_order.isfinishorder,
            iseverythingasdescription: ghat_re_order.iseverythingasdescription,
            approval_items: ghat_re_order.approval_items
              ? ghat_re_order.approval_items
                  ?.filter(
                    (item: any) =>
                      item?.type &&
                      item?.item_id &&
                      item?.weight &&
                      item?.qty &&
                      item?.unit_id,
                  )
                  ?.map((app: any) => ({
                    id: app?.id ? app?.id : 0,
                    type: app?.type,
                    item_id: app?.item_id,
                    weight: app?.weight,
                    qty: app?.qty,
                    unit_id: app?.unit_id,
                    used_weight: app?.used_weight,
                    return_weight: app?.return_weight,
                    balance_weight: app?.balance_weight,
                    customer_less_weight: app?.customer_less_weight,
                    custom_rate: app?.custom_rate,
                  }))
              : [],
            item_used_by_kariagr: ghat_re_order.item_used_by_kariagr
              ? ghat_re_order.item_used_by_kariagr
                  ?.filter(
                    (item: any) =>
                      item?.item_id &&
                      item?.weight &&
                      item?.qty &&
                      item?.unit_id &&
                      item?.apply_on &&
                      item?.rate,
                  )
                  ?.map((karigar: any) => ({
                    id: karigar?.id ? karigar?.id : 0,
                    item_id: karigar?.item_id,
                    weight: karigar?.weight,
                    qty: karigar?.qty,
                    apply_on: karigar?.apply_on,
                    unit_id: karigar?.unit_id,
                    rate: karigar?.rate ? karigar?.rate : 0,
                    total: karigar?.total ? karigar?.total : 0,
                    custom_rate: karigar?.custom_rate
                      ? karigar?.custom_rate
                      : 0,
                    customer_less_weight: karigar?.customer_less_weight
                      ? karigar?.customer_less_weight
                      : 0,
                  }))
              : [],
          }))
        : [],
    };

    if (ghat_receipt_guid) {
      const editPayload = {
        ...formdata,

        ghat_receipt_guid: ghat_receipt_guid,
      };
      try {
        const response = await dispatch(updateGhatReceipt(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (ghat_receipt_guid) {
            dispatch(getGhatReceiptById(ghat_receipt_guid));
          }
          dispatch(closeDialog());
          navigate("/ghatissuereceipt/edit", {
            state: {
              ghat_receipt_guid: ghat_receipt_guid,
            },
          });
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const response = await dispatch(createGhatReceipt(formdata));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closeDialog());
          navigate("/ghatissuereceipt/edit", {
            state: {
              ghat_receipt_guid: response.payload.ghat_receipt_guid,
            },
          });
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {formLoading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={GhatReceiptDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <GhatOrderEntryChangeWatcher formRenderProps={formRenderProps} />
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "33%" }, { width: "33%" }, { width: "33%" }]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {ghat_receipt_guid
                      ? "Update Ghat Receipt"
                      : "Create Ghat Receipt"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="karigar_id"
                    label="Karigar Name"
                    placeholder="Select Karigar"
                    isAddNew={true}
                    addNewLink="karigar/create"
                    dispatcherFunction={getKarigarListByProcess}
                    dispatcherFunctionPayload={PROCESS_ID.ghat}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={KarigarListByProcess?.map(
                      (karigar: IKarigarListByProcess) => {
                        return {
                          value: karigar?.karigar_id,
                          label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                        };
                      },
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="receipt_date"
                    label="Receipt Date"
                    placeholder="day/month/year"
                    format={"dd/MM/yyyy"}
                    max={maxDate}
                    component={FormDatePicker}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <div className="stock-container">
                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot amount-dot-${karigarStock.Amount_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Amount Balance
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value amount-value-${karigarStock.Amount_credit_debit}`}
                      >
                        {formatToIndianCurrencyWithoutSymbol(
                          karigarStock.amount || 0,
                        )}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.Amount_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>

                    <div className="stock-item">
                      <div className="stock-header">
                        <div
                          className={`indicator-dot phine-dot-${karigarStock.phine_credit_debit}`}
                        ></div>
                        <Typography.h6 className="stock-label">
                          Phine (gm) Stock
                        </Typography.h6>
                      </div>
                      <Typography.h6
                        className={`stock-value phine-value-${karigarStock.phine_credit_debit}`}
                      >
                        {formatWeight(karigarStock.phine)}{" "}
                        <span
                          style={{
                            fontWeight: "normal",
                            textTransform: "capitalize",
                            fontSize: 16,
                          }}
                        >
                          {karigarStock.phine_credit_debit}
                        </span>
                      </Typography.h6>
                    </div>
                  </div>
                </GridLayoutItem>
                {/* <GridLayoutItem>
                  <Field
                    id={"IsActive"}
                    name={"isactive"}
                    label={"Status"}
                    component={FormSelectionField}
                    validator={requiredValidator}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status.value,
                        label: status.label,
                      };
                    })}
                  />
                </GridLayoutItem> */}
              </GridLayout>
            </ShadowCard>

            <ShadowCard style={{ marginTop: 10, padding: 12 }}>
              {/* THIS IS FOR LISTING */}
              <FieldArray
                formRenderProps={formRenderProps}
                component={GhatReceiptOrderArray}
                name="ghat_receipt_order"
              />
              {/* THIS IS FOR DIALOG */}
              <FieldArray
                formRenderProps={formRenderProps}
                component={GhatReceiptOrderEntryArray}
                name="ghat_receipt_order"
              />
              <GridLayoutItem
                colSpan={3}
                style={{
                  textAlign: "end",
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                {isPrintAccess && ghat_receipt_guid && (
                  <Button
                    type="button"
                    style={{ marginRight: 4 }}
                    fillMode={"solid"}
                    themeColor={"primary"}
                    onClick={() =>
                      window.open(
                        `/ghatissuereceipt/${ghat_receipt_guid}`,
                        "_blank",
                      )
                    }
                  >
                    <FaEye style={{ fontSize: "18" }} /> View Report
                  </Button>
                )}
                <ButtonWithLoading
                  type="submit"
                  label={!ghat_receipt_guid ? "Create" : "Update"}
                  themeColor={"primary"}
                  fillMode={"solid"}
                  disabled={!formRenderProps.allowSubmit || formLoading}
                  loading={formLoading}
                />
                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 4 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateGhatReceipt;
